import { useGetPlatformSettings, useSetPlatformSecurity } from '@myrentalmate/api-client';
import {
  Alert,
  FormControlLabel,
  Link as MuiLink,
  Paper,
  Stack,
  Switch,
  Typography,
} from '@mui/material';
import { useQueryClient } from '@tanstack/react-query';
import { Link } from 'react-router';

import { TabbedLayout } from '../../components/TabbedLayout';
import { okData } from '../../lib/apiData';
import { apiErrorMessage } from '../../lib/apiError';
import { useMe } from '../../lib/me';

const TABS = [
  { to: '/platform/settings', label: 'General' },
  { to: '/platform/settings/security', label: 'Security' },
];

export function PlatformSettingsLayout() {
  return <TabbedLayout title="App Settings" label="App settings sections" tabs={TABS} />;
}

export function PlatformSecurityPage() {
  const { data: me } = useMe();
  const queryClient = useQueryClient();
  const settings = okData(useGetPlatformSettings().data);
  const save = useSetPlatformSecurity({
    mutation: { onSuccess: () => queryClient.invalidateQueries() },
  });
  return (
    <Paper variant="outlined" sx={{ p: 3, maxWidth: 640 }}>
      <Typography variant="h6">Two-Factor for Platform Admins</Typography>
      <Typography color="text.secondary" sx={{ mb: 2 }}>
        Platform admins can open any customer's records, so a stolen password here is the most
        serious kind. This is optional, and we recommend turning it on. It applies to platform
        admins only. Each customer chooses for their own staff.
      </Typography>
      <Stack spacing={2} sx={{ alignItems: 'flex-start' }}>
        <FormControlLabel
          label="Require Two-Factor for All Platform Admins"
          control={
            <Switch
              checked={settings?.mfa_required ?? false}
              disabled={!settings || save.isPending}
              onChange={(e) => save.mutate({ data: { mfa_required: e.target.checked } })}
            />
          }
        />
        {settings && !settings.two_factor_available && (
          <Alert severity="warning">Two-factor isn't set up on this release yet.</Alert>
        )}
        {me && !me.mfa_enabled && (
          <Alert severity="info">
            To turn this on, first set up two-factor for yourself in{' '}
            <MuiLink component={Link} to="/account">
              My profile
            </MuiLink>
            .
          </Alert>
        )}
        {save.isError ? <Alert severity="error">{apiErrorMessage(save.error)}</Alert> : null}
      </Stack>
    </Paper>
  );
}
